export const compProps = {
    databaseId: 35,
    label: 'Ready to Find a Lender?',
    sublabel: '',
    submenu: {
        nodes: [
            {
                databaseId: 36,
                label: 'Buy A Home',
                src: 'https://mortgage.quickenloans.com/#sourceid-buy',
                testId: 'buy_a_home_button',
            },
            {
                databaseId: 37,
                label: 'Refinance',
                src: 'https://refinance.quickenloans.com/?moid=322646#sourceid-refi',
                testId: 'refinance_button',
            },
        ],
    },
};

export const compPropsForLender = {
    databaseId: 35,
    label: 'See What You Qualify For',
    sublabel: '',
    submenu: {
        nodes: [
            {
                databaseId: 36,
                label: 'Buy A Home',
                src: 'https://mortgage.quickenloans.com/lending/home-loan/#sourceid-buy',
                testId: 'buy_a_home_button',
            },
        ],
    },
};

export const testAttributes = {
    BANNER_CONTAINER: 'lender-cta_banner-container',
    BANNER_HEADLINE: 'lender-cta_banner-headline',
    BANNER_SUBHEADLINE: 'lender-cta_banner-subheadline',
    BANNER_DESCRIPTION: 'lender-cta_banner-description',
    BANNER_LIST: 'lender-cta_banner-list',
    BANNER_BUTTON: 'lender-cta_banner-btn-',
};
